import { Injectable } from '@angular/core';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { HistoryRef } from '@finder/shared/services/history-ref/history-ref.service';
import { ScrollToServiceOptions } from '@finder/shared/services/scroll-to/scroll-to.interface';

@Injectable({
    providedIn: 'root',
})
export class ScrollToService {
    // TODO - proper test coverage
    /* istanbul ignore next */
    get window() {
        return this.windowRef.nativeWindow;
    }

    // TODO - proper test coverage
    /* istanbul ignore next */
    get history() {
        return this.historyRef.nativeApi;
    }

    constructor(
        private windowRef: WindowRef,
        private historyRef: HistoryRef,
    ) {}

    // TODO - proper test coverage
    /* istanbul ignore next */
    scrollToElement(domElement, opt?: boolean | ScrollToServiceOptions) {
        // Smooth was the 2nd param, but top offset was also needed as a param later
        // So now we check for an object param, or just a bool param value, or use the
        // original fallback of `false`
        const scrollOptions = opt as ScrollToServiceOptions;
        const smooth = scrollOptions.smooth ?? opt ?? false;

        // avoid browser scroll to last position in the web app
        this.history.scrollRestoration = 'manual';

        /**
         * we can't use offsetTop. This only gives the distance to the next parent.
         * if it's nested then the value can be 0.
         *
         * getBoundingClientRect will return the distance to the top of the page
         * but if the scrollbar isn't at the top of the page we'll get the wrong
         * value. including the scrollbar position makes up for this
         * https://stackoverflow.com/a/33840267/122236
         */
        this.window.scrollTo({
            left: 0,
            top: domElement.getBoundingClientRect().top +
                this.window.scrollY +
                (scrollOptions.offsetTop ?? 0), // Allows us to add some "padding" if needed
            behavior: smooth ? 'smooth' : 'auto',
        });
    }
}
